import { assign, reduce } from 'lodash';
import { ResourcePolicy } from '@/policies';
import { auth } from '@/services';
import { iResource } from '@/interfaces/resources';
import { IController, ILocationService, resource } from 'angular';

// todo: can this be a generic interface that's useable elsewhere?
interface IFilters {
    categories: number[];
    page: number,
    page_size: number,
    search: string,
}

interface IFilterParams {
    "categories[]"?: number[];
    page?: number,
    page_size?: number,
}

class Controller implements IController {
    public static $inject = [
        '$location',
        'PostsSearchApi',
        'Resources',
        'ResourcesApi',
        'resourcesPayload',
    ];

    /**
     * The filters to apply when getting resources.
     */
    public filters: IFilters = {
        categories: [],
        page: 1,
        page_size: 12,
        search: '',
    };

    /**
     * Whether the component is currently loading.
     */
    public isLoading: boolean = false;

    /**
     * Permission checks
     * todo: we could probably build a component to do this so that controllers don't have to.
     */
    public permissionChecks = {
        canCreate: ResourcePolicy.canCreate(auth.user()),
    };

    /**
     * The resources to render.
     * todo: Requires an interface
     */
    public resources: any;

    /**
     * The $location service.
     */
    protected $location: ILocationService;

    /**
     * The PostsSearchApi resource service.
     */
    protected postsSearchApi: resource.IResourceClass<iResource>;

    /**
     * The ResourcesApi resource service.
     */
    protected resourcesApi: resource.IResourceClass<iResource>;

    /**
     * The resource manager.
     * todo: Requires an interface.
     */
    protected resourceManager: any;

    /**
     * @param $location
     * @param postsSearchApi
     * @param resourceManager
     * @param resourcesApi
     * @param resources
     */
    public constructor(
        $location: ILocationService,
        postsSearchApi: resource.IResourceClass<iResource>,
        resourceManager: any,
        resourcesApi: resource.IResourceClass<iResource>,
        resources: any,
    ) {
        this.$location = $location;
        this.postsSearchApi = postsSearchApi;
        this.resourceManager = resourceManager;
        this.resourcesApi = resourcesApi;
        this.resources = resources;

        this.onCategoryChange = this.onCategoryChange.bind(this);
        // todo: this is gunna get spread across multiple places as we implement categories elsewhere, so it should be put somewhere.
        this.filters.categories = [].concat($location.search()['categories[]'] || []).map(id => parseInt(id));
    }

    /**
     * Opens a createResource model.
     */
    public createResource(): void {
        this.resourceManager.manageResource().then(this.fetchResources);
    }

    /**
     * Fetches resources from the API.
     */
    public fetchResources(): void {
        this.isLoading = true;

        this.resourcesApi
            .get(
                this.filtersToParams(),
                (response: any) => {
                    this.resources = response;
                    console.log("resources==========>", response)
                    this.isLoading = false;
                },
                () => this.isLoading = false,
            );
    }

    /**
     * Handles category changes.
     * @param selected
     */
    public onCategoryChange(selected: number[]): void {
        this.filters.categories = selected;
        this.fetchResources();
    }

    /**
     * Originally looped though local resources and spliced, but now fetches
     * from the API.
     * @param resource
     */
    public onDelete(resource: iResource): void {
        this.fetchResources();
    }

    /**
     * Searches resources (also clears categories, because search doesn't support categories.)
     */
    public searchResources(): void {
        // No need to trouble Solr if we have no search string.
        if (!this.filters.search || this.filters.search === '') {
            this.fetchResources();
            return;
        }

        this.isLoading = true;

        this.$location.search('categories[]');

        // We clear categories because the API can't apply cagegories to search results...
        this.filters.categories = [];
        this.postsSearchApi
            .get(
                { q: this.filters.search, type: 'resource' },
                (response: any) => {
                    this.resources.data = response.results;
                    this.isLoading = false;
                },
                () => this.isLoading = false,
            );
    }

    /**
     * Reduces filters to params.
     */
    protected filtersToParams(): IFilterParams {
        return reduce(this.filters, (filters, value, key) => {
            switch (key) {
                case 'search':
                    return filters;

                case 'categories':
                    return assign(filters, { 'categories[]': value });

                default:
                    return assign(filters, { [key]: value });
            }
        }, {});
    }

    /**
     * Load more resources
     */
    public loadMore(): void {
        this.filters.page_size += 12;
        this.fetchResources();
    }
}

angular.module('app')
    .controller('resourcesController', Controller);